<template>
  <header class="grid-column x8">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: "Header",
  components: {},
};
</script>
<style scoped>
header {
  height: calc(var(--LINE-HEIGHT) * 3);
  font-size: 0;
  position: relative;
}

@media only screen and (max-width: 576px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue